'use strict';

export const breakpoints = {
    mobile: 768,
    desktop: 1024,
    desktopLarge: 1680
};

/**
 * Returns true if viewport is < desktop breakpoint.
 */
export const isMobile = () =>
    window.matchMedia(`(max-width: ${breakpoints.desktop - 1}px)`).matches;

/**
 * Returns true if viewport is >= desktop breakpoint.
 */
export const isDesktop = () =>
    window.matchMedia(`(min-width: ${breakpoints.desktop}px)`).matches;
